<template>
  <base-dialog @cancel="cancelDialog" width="1200px">
    <div slot="header">云账号配置向导</div>
    <div slot="body">
      <cloud-account-setup-guide />
    </div>
    <div slot="footer">{{''}}</div>
  </base-dialog>
</template>

<script>
import CloudAccountSetupGuide from '../components/CloudAccountSetupGuide'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'CloudAccountSetupGuideDialog',
  components: { CloudAccountSetupGuide },
  mixins: [DialogMixin, WindowsMixin],
}
</script>

<style scoped>

</style>
